import { IonButton, IonInput, IonTextarea, IonLabel, IonAlert, IonIcon, IonRow, IonCol, IonPage, IonContent } from "@ionic/react";
import React, { useState } from "react";
import './CreditPayDirect.scss';
import { copyOutline, copySharp, returnUpBackOutline } from "ionicons/icons"
import { User } from "../models/data";
import AdminUsers from "../services/adminUserList";
import Footer from "./Footer";
import { translation } from "../models/translation";

interface DirectPayProps {
    changePaymentMethod: any,
}

const CreditPayDirect: React.FC<DirectPayProps> = ({ changePaymentMethod, ...rest }) => {

    const AdminList = AdminUsers();

    const siteText = translation();
    const lan = siteText.lan;

    const paymentInfo = [
        {
            name: "accountholder", data: {
                fieldName: "Account holder",
                text: "SwissDonations"
            }
        },
        {
            name: "address", data: {
                fieldName: "Address",
                text: "SwissDonations,\n ch. du Presbytère 5,\n 1294 Genthod"
            }
        },
        {
            name: "bankname", data: {
                fieldName: "Bank name",
                text: "Alternative Bank Schweiz AG"
            }
        },
        {
            name: "bankaddress", data: {
                fieldName: "Bank address",
                text: "Rue du Port-Franc 11, \nC.P. 161, \n1003 Lausanne"
            }
        },
        {
            name: "iban", data: {
                fieldName: "IBAN",
                text: "CH39 0839 0038 7188 1000 1"
            }
        },
        {
            name: "bic", data: {
                fieldName: "BIC (Swift)",
                text: "ABSOCH22XXX"
            }
        },
        {
            name: "iid", data: {
                fieldName: "IID (clearing number)",
                text: "8390"
            }
        }

    ]

    const [success, setSuccess] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertField, setAlertField] = useState('');

    const setCopy = (content: string, alertFieldName: string) => {
        setAlertField(alertFieldName);
        navigator.clipboard.writeText(content)
            .then(() => { animateAlerte() })
            .catch((error) => { alert(`Copy failed! ${error}`) })
    }

    const animateAlerte = () => {
        setShowAlert(true);
        setTimeout(() => { setShowAlert(false) }, 300)
    }

    return (<IonPage className="viewContainer">
        <IonContent className="ion-padding">
            <IonRow>
                <IonCol>
                    <IonRow>
                        <IonCol sizeXs="12" sizeSm="11">
                            <IonButton onClick={changePaymentMethod} color="light"><IonIcon icon={returnUpBackOutline}></IonIcon></IonButton>
                        </IonCol>
                        <IonCol>
                            <h2>{siteText.paymentDetailsTitle}</h2>
                        </IonCol>
                    </IonRow>
                    <IonAlert
                        isOpen={showAlert}
                        onDidDismiss={() => setShowAlert(false)}
                        cssClass='my-custom-class'
                        message={`<strong>${alertField}</strong>: copied to clipboard`}
                    />
                    <IonRow className="paymentInfo">
                        <IonCol  sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsAccountholder.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonTextarea rows={3} className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsAccountholder.text} placeholder={siteText.paymentDetailsAccountholder.text}></IonTextarea>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsAccountholder.fieldName, siteText.paymentDetailsAccountholder.text) }} fill="clear" size="small" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>
                        <IonCol  sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsAddress.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonTextarea rows={3} className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsAddress.text} placeholder={siteText.paymentDetailsAddress.text}></IonTextarea>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsAddress.fieldName, siteText.paymentDetailsAddress.text) }} fill="clear" size="small" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>
                        <IonCol sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsBankname.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonInput className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsBankname.text} placeholder={siteText.paymentDetailsBankname.text}></IonInput>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsBankname.text, siteText.paymentDetailsBankname.fieldName) }} fill="clear" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>
                        <IonCol sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsBankaddress.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonInput className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsBankaddress.text} placeholder={siteText.paymentDetailsBankaddress.text}></IonInput>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsBankaddress.text, siteText.paymentDetailsBankaddress.fieldName) }} fill="clear" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>
                        <IonCol sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsIban.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonInput className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsIban.text} placeholder={siteText.paymentDetailsIban.text}></IonInput>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsIban.text, siteText.paymentDetailsIban.fieldName) }} fill="clear" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>
                        <IonCol sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsBic.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonInput className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsBic.text} placeholder={siteText.paymentDetailsBic.text}></IonInput>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsBic.text, siteText.paymentDetailsBic.fieldName) }} fill="clear" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>
                        <IonCol sizeXs="12" sizeSm="6">
                            <IonLabel>{siteText.paymentDetailsIid.fieldName}</IonLabel>
                            <div className="copygroup">
                                <IonInput className="ion-margin-bottom ion-margin-top" readonly value={siteText.paymentDetailsIid.text} placeholder={siteText.paymentDetailsIid.text}></IonInput>
                                <IonButton onClick={() => { setCopy(siteText.paymentDetailsIid.text, siteText.paymentDetailsIid.fieldName) }} fill="clear" color="medium"><IonIcon md={copyOutline} ios={copySharp} slot="icon-only"></IonIcon></IonButton>
                            </div>
                        </IonCol>


                    </IonRow>
                    
                </IonCol>
            </IonRow>

            <Footer></Footer>
        </IonContent>
    </IonPage>
    )
}

export default CreditPayDirect;